export const ModuleProxyFactory = [
  'function deployModule(address masterCopy, bytes memory initializer, uint256 saltNonce)'
]
